import React, { useState } from "react";
import HeightSlider from "../../Components/HeightSlider";
import WeightSlider from "../../Components/WeightSlider";
import { images } from "../../Assets/images";

const SurveyForm = () => {
    const [formData, setFormData] = useState({});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const updateUserData = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const foodItems = [
        {
            label: "Fruits",
            name: "fruits",
            image: images.fruit,
        },
        {
            label: "Vegetables",
            name: "vegetables",
            image: images.vegetable,
        },
        {
            label: "Whole Grains",
            name: "wholeGrains",
            image: images.wholeGrain,
        },
        {
            label: "Dairy",
            name: "dairy",
            image: images.dairy,
        },
        {
            label: "Sugar",
            name: "sugar",
            image: images.sugar,
        },
    ];

    const meatItems = [
        {
            label: "Red Meat",
            name: "redMeat",
            image: images.redMeat,
        },
        {
            label: "Fish",
            name: "fish",
            image: images.fish,
        }
    ];

    const lifestyleQuestions = [
        {
            label: "How often do you eat the same meal?",
            name: "sameMeal",
            image: images.meal, // add your icon
            options: [
                "2 or more times per week",
                "Once a week",
                "2–3 times per month",
                "Once a month or less",
            ],
        },
        {
            label: "How often do you have a bowel movement?",
            name: "bowelMovement",
            image: images.bowel, // add your icon
            options: [
                "Once every 3 or more days",
                "Once every 1–2 days",
                "Once a day",
                "2–3 times a day",
                "More than 3 times a day",
            ],
        },
        {
            label: "How much time do you spend sitting each day?",
            name: "sittingTime",
            image: images.sitting, // add your icon
            options: [
                "1–2 hours",
                "3–4 hours",
                "5–7 hours",
                "8 or more hours",
            ],
        },
    ];

    return (
        <div className="content-part">

            <div className="survey-card">
                <h3 className="survey-heading">Healthy Assessment</h3>

                <div className="row">

                    <div className="col-md-4">
                        <div className="mb-3">
                            <label className="fw-semibold form-label">Gender</label>

                            <div className="d-flex align-items-center gap-3">
                                <div
                                    className={`gender-box ${formData.gender === "male" ? "selected-gender" : ""
                                        }`}
                                    onClick={() =>
                                        setFormData((prev) => ({ ...prev, gender: "male" }))
                                    }
                                >
                                    <div className="gender-img">
                                        <img src={images.maleImg} alt="male" />
                                    </div>
                                    <span className="mt-1">Male</span>
                                </div>

                                <div
                                    className={`gender-box ${formData.gender === "female" ? "selected-gender" : ""
                                        }`}
                                    onClick={() =>
                                        setFormData((prev) => ({ ...prev, gender: "female" }))
                                    }
                                >
                                    <div className="gender-img">
                                        <img src={images.femaleImg} alt="female" />
                                    </div>
                                    <span className="mt-1">Female</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Age */}
                    <div className="col-6">
                        <div className="mb-3">
                            <div className="input-image">
                                <img src={images.age} alt="age" className="mb-2" />
                            </div>
                            <label className="form-label">Age</label>
                            <input
                                type="number"
                                name="age"
                                className="form-control"
                                placeholder="Enter age"
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="mb-3">
                            <div className="input-image">
                                <img src={images.smoke} alt="smoke" className="mb-2" />
                            </div>
                            <label className="form-label">Do you smoke?</label>
                            <select
                                name="smoke"
                                className="form-select"
                                onChange={handleChange}
                            >
                                <option>No</option>
                                <option>Yes</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <div className="">
                            <div className="input-image">
                                <img src={images.height} alt="height" className="mb-2" />
                            </div>
                            <HeightSlider
                                value={formData.height || 66}
                                onChange={(val) => updateUserData("height", val)}
                            />
                        </div>
                    </div>
                </div>

                <div className="row">

                    <div className="col-md-4">
                        <div className="input-image">
                            <img src={images.weight} alt="weight" className="mb-2" />
                        </div>
                        <WeightSlider
                            value={formData.weight || 66}
                            onChange={(val) => updateUserData("weight", val)}
                        />
                    </div>

                    <div className="col-md-4 mt-3">
                        <div className="input-image">
                            <img src={images.drink} alt="drink" className="mb-2" />
                        </div>
                        <label className="form-label fw-semibold">Alcohol per day</label>
                        <select
                            name="alcohol"
                            className="form-select"
                            onChange={handleChange}
                        >
                            <option>None</option>
                            <option>1 drink</option>
                            <option>2-3 drinks</option>
                            <option>4+ drinks</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="survey-card">
                <h5 className="survey-heading">
                    How many servings do you eat of these food groups every day?
                </h5>

                <div className="row">
                    {foodItems.map((item) => (
                        <div className="col-6 mt-3" key={item.name}>

                            <div className="input-image">
                                <img
                                    src={item.image}
                                    alt={item.label}
                                    className="food-icon"
                                />
                            </div>

                            <label className="form-label fw-semibold">
                                {item.label}
                            </label>

                            <select
                                name={item.name}
                                className="form-select"
                                onChange={handleChange}
                            >
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3+">3+</option>
                            </select>
                        </div>
                    ))}
                </div>
            </div>

            <div className="survey-card">
                <h5 className="survey-heading">
                    How many times a week do you eat the following?
                </h5>

                <div className="row mt-3">
                    {meatItems.map((item) => (
                        <div className="col-6 mb-3" key={item.name}>
                            <div className="input-image">
                                <img
                                    src={item.image}
                                    alt={item.label}
                                    className="food-icon"
                                />
                            </div>
                            <label className="form-label fw-semibold">{item.label}</label>
                            <select
                                name={item.name}
                                className="form-select"
                                onChange={handleChange}
                            >
                                <option>0</option>
                                <option>1-2</option>
                                <option>3-4</option>
                                <option>5+</option>
                            </select>
                        </div>
                    ))}
                </div>
            </div>

            <div className="survey-card">
                <h5 className="survey-heading">
                    Lifestyle & Daily Habits
                </h5>

                <div className="row">
                    {lifestyleQuestions.map((question) => (
                        <div className="col-md-4 mt-3" key={question.name}>

                            {/* Icon */}
                            <div className="input-image">
                                <img
                                    src={question.image}
                                    alt={question.label}
                                    className="lifestyle-icon"
                                />
                            </div>

                            <label className="form-label fw-semibold">
                                {question.label}
                            </label>

                            {question.options.map((option, index) => (
                                <div className="form-check ps-0 mt-2" key={index}>
                                    <div className="custom-checkbox form-check p-0">
                                        <input id={option} type="radio" value={option} name={question.name} />
                                        <label className="custom-label" htmlFor={option}>{option}</label>
                                    </div>
                                </div>
                            ))}

                        </div>
                    ))}
                </div>
            </div>

            <div className="survey-card">
                <h5 className="survey-heading mb-0">
                    How many times per week do you spend at least 30 minutes doing the following types of activity?
                </h5>

                <div className="row my-3">
                    {[
                        {
                            label: "Light Activity",
                            desc: "(Minimal exertion, can talk easily or even sing)",
                            name: "lightActivity",
                            image: images.lightActivity,
                        },
                        {
                            label: "Moderate Activity",
                            desc: "(Heavier breathing, can talk with some effort, little to moderate sweating)",
                            name: "moderateActivity",
                            image: images.moderateActivity,
                        },
                        {
                            label: "Intense Activity",
                            desc: "(Labored breathing, difficult to talk, heavy sweating)",
                            name: "intenseActivity",
                            image: images.intenseActivity,
                        },
                    ].map((item) => (
                        <div className="col-md-4 mt-3" key={item.name}>
                            <div className="input-image">
                                <img src={item.image} alt={item.label} className="activity-icon" />
                            </div>

                            <label className="form-label mb-0 fw-semibold">{item.label}</label>
                            <p className="mb-0 small text-muted">{item.desc}</p>

                            {[
                                "I don't do this kind of activity",
                                "1–2 times",
                                "3–4 times",
                                "5+ times",
                            ].map((option, index) => (
                                <div className="form-check text-start ps-0 mt-2" key={index}>
                                    <div className="custom-checkbox form-check p-0">
                                        <input
                                            id={`${item.name}-${index}`}
                                            type="radio"
                                            value={option}
                                            name={item.name}
                                            onChange={handleChange}
                                            checked={formData[item.name] === option}
                                        />
                                        <label className="custom-label" htmlFor={`${item.name}-${index}`}>{option}</label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <div className="input-image">
                            <img src={images.stress} alt="stress" className="small-icon" />
                        </div>
                        <label className="form-label fw-semibold">Please rate your current level of stress:</label>

                        {[
                            "No stress",
                            "Between no stress and moderate stress",
                            "Moderate stress",
                            "Between moderate stress and extreme stress",
                            "Extreme stress",
                        ].map((option, index) => (
                            <div className="form-check ps-0 text-start mt-2" key={index}>
                                <div className="custom-checkbox form-check p-0"><input id={option} type="radio" value={option} name="stress" /><label className="custom-label" htmlFor={option}>{option}</label></div>
                            </div>
                        ))}
                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="input-image mb-2">
                            <img src={images.sleep} alt="sleep" className="small-icon" />
                        </div>
                        <label className="form-label fw-semibold">How many nights a week do you sleep for five hours or less?</label>

                        {[
                            "0 nights",
                            "1–2 nights",
                            "3–4 nights",
                            "5–6 nights",
                            "Every night",
                        ].map((option, index) => (
                            <div className="form-check ps-0 text-start mt-2" key={index}>
                                <div className="custom-checkbox form-check p-0"><input id={option} type="radio" value={option} name="sleep" /><label className="custom-label" htmlFor={option}>{option}</label></div>
                            </div>
                        ))}
                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="input-image mb-2">
                            <img src={images.energy} alt="energy" className="small-icon" />
                        </div>
                        <label className="form-label fw-semibold">Please rate your energy level:</label>

                        {[
                            "No energy",
                            "Between no energy and a little energy",
                            "Some energy",
                            "Between some energy and plenty of energy",
                            "Plenty of energy",
                        ].map((option, index) => (
                            <div className="form-check ps-0 text-start mt-2" key={index}>
                                <div className="custom-checkbox form-check p-0"><input id={option} type="radio" value={option} name="energy" /><label className="custom-label" htmlFor={option}>{option}</label></div>
                            </div>
                        ))}
                    </div>

                    {/* Immune */}
                    <div className="col-md-3">
                        <div className="input-image mb-2">
                            <img src={images.immune} alt="immune" className="small-icon" />
                        </div>
                        <label className="form-label fw-semibold">Please rate the strength of your immune system:</label>

                        {[
                            "Weak",
                            "Between weak and moderate",
                            "Moderate",
                            "Between moderate and strong",
                            "Strong",
                        ].map((option, index) => (
                            <div className="form-check ps-0 text-start mt-2" key={index}>

                                <div className="custom-checkbox form-check p-0"><input id={option} type="radio" value={option} name="immune" /><label className="custom-label" htmlFor={option}>{option}</label></div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            <div className="survey-card">

                <h5 className="survey-heading">
                    What areas of your health would you like to support?
                </h5>

                <div className="row">
                    {[
                        "Heart Health",
                        "Immune Support",
                        "Weight Management",
                        "Energy",
                        "Sleep",
                        "Digestive Health",
                    ].map((goal) => (
                        <div className="col-md-4 mt-1" key={goal}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name={goal}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label">{goal}</label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            {/* Submit */}
            <div className="text-center my-3">
                <button className="btn btn-primary">
                    Submit Assessment
                </button>
            </div>
        </div>
    );
};

export default SurveyForm;